const messages = {
    dashboard: {
        title: "Dashboard",
        extraTitle: "DASHBOARD",
        description:
            "Welkom op uw dashboard. Uw acties en uw punten in één oogopslag",
        overview: {
            title: "Overzicht van deelnemende klanten",
            description:
                "Bedrijven die zich hebben geregistreerd bij BRIDGESTONE PLUS en die we via hun klantnummer aan uw bedrijven kunnen toewijzen.",
            month: "Nieuw deze maand",
            year: "Nieuw dit jaar",
            all: "Totaal",
        },
        credits: {
            title: "Puntenkredieten {name}",
            description:
                "Beloningspunten toegekend aan deelnemende bedrijven op basis van de door u geüploade verkoopcijfers. In dit overzicht worden de reguliere punten weergegeven zonder promoties.",
            month: "Laatste maand",
            year: "Huidig jaar",
            prev_year: "Totaal",
            allDealers: "Alle punten van handelaars",
        },
        details: {
            title: "Details van deelnemende klanten",
            description:
                'Hieronder vindt u de bedrijven die zich hebben geregistreerd bij BRIDGESTONE <span class="text-danger">PLUS</span> met een klantnummer {name} en aan u zijn toegewezen als verantwoordelijke. Gebruik gewoon de sorteerfuncties om de volgorde te wijzigen of gebruik het zoekveld.',
        },
        lastImport:
            'Laatste import van verkoopcijfers: <br/> <span class="text-danger">{date}</span>',
        loadMore: "Laad 20 extra handelaars",
        tyres: {
            title: "Banden",
            description: "Banden gekocht door programma-deelnemers",
        },
    },
};

export default {
    messages,
};
